import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import * as selectors from './selectors';
import * as dataValueLookupActions from '../../actions/DataValueLookupActions';
import * as searchTreeViewDataActions from '../../actions/SearchTreeViewDataActions';
import { getUITA } from '../../utils/commonUtils';
import AdvSearchModal from '../AdvancedSearchModal';
import { DEFAULT_SELECT_VALUE } from '../AdvancedSearchModal/Criterion/constants';

function AdvancedSearchModal({
  initialCriteria,
  defaultCriteria,
  customAdvancedSearchCriteria = [],
  columns,
  onSearch,
  dataKey,
  entityName,
  searchName,
  viewName,
  getSearchTreeViewData,
  getLookupValues,
  ...popoverProps
}) {
  const [criteria, setCriteria] = useState();

  useEffect(() => {
    if (popoverProps.open) {
      setCriteria((initialCriteria || defaultCriteria || []).concat(customAdvancedSearchCriteria));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [popoverProps.open]);

  useEffect(() => {
    if (popoverProps.open) {
      getSearchTreeViewData(entityName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entityName, popoverProps.open]);

  const handleCriteriaChange = (index, update) => {
    setCriteria(criteria.map((c, i) => (i === index ? { ...c, ...update } : c)));
  };

  const handleLookup = (column, index) => {
    const [table, field] = column.split('.');
    getLookupValues(table, field).then(
      (lookupValues) => Array.isArray(lookupValues) && handleCriteriaChange(index, { lookupValues })
    );
  };

  return (
    <AdvSearchModal
      {...popoverProps}
      ui-ta={getUITA('AdvancedSearch Modal')}
      viewName={viewName}
      criteria={criteria}
      columns={columns}
      onAddCriterion={() =>
        setCriteria([
          ...criteria,
          {
            id: uuidv4(),
            openGroup: DEFAULT_SELECT_VALUE,
            closeGroup: DEFAULT_SELECT_VALUE,
            value: '',
            relationalOperator: 'and',
            allowEditting: true,
            enableLookup: true,
          },
        ])
      }
      onCriterionChange={handleCriteriaChange}
      onCriterionDelete={(index) => {
        setCriteria(criteria.filter((_, i) => i !== index));
      }}
      onSearch={() => {
        onSearch(criteria);
      }}
      onLookup={handleLookup}
    />
  );
}

function treeViewDataToOptions(treeViewData) {
  if (_.isNil(treeViewData)) {
    return [];
  }

  const id = treeViewData.Value || uuidv4();
  const value = treeViewData.IsSelectable ? treeViewData.Value : id;

  const newOption = {
    id,
    value,
    dataType: treeViewData.ColumnType,
    text: treeViewData.Text,
    group: !treeViewData.IsSelectable,
  };

  return [newOption].concat(
    treeViewData.Items
      ? _.flattenDeep(treeViewData.Items.map((item) => treeViewDataToOptions(item)))
      : []
  );
}

function mapStateToProps(state, props) {
  const { searchTreeViewData } = state;
  const treeViewDataState = searchTreeViewData[props.entityName];

  return {
    defaultCriteria: selectors.getDefaultCriteriaForPopover(state, props),
    viewName: selectors.getViewName(state, props),
    columns:
      treeViewDataState && treeViewDataState.searchTreeViewData
        ? treeViewDataToOptions(treeViewDataState.searchTreeViewData)
        : [],
  };
}

export default connect(mapStateToProps, {
  getSearchTreeViewData: searchTreeViewDataActions.getSearchTreeViewData,
  getLookupValues: dataValueLookupActions.getLookupValues,
})(AdvancedSearchModal);
